import React, { useState } from 'react';
import { TextField, Button, Switch, FormControlLabel, Box, Typography } from '@mui/material';
import { PlusCircle, ArrowLeft, ChevronLeft, User } from 'react-feather';
import Grid from '@mui/material/Grid2';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authApi } from '../../api/api';
import { logout } from '../../features/auth/AuthSlice';
import Toastmessage from '../../components/Toast';
import { set } from 'date-fns';


export default function AddDesignation() {
  const [active, setActive] = useState(true);
  const [designationName, setDesignationName] = useState('');
  const [errors, setErrors] = useState({});

  const [isLoading, setIsloading] = useState(false);

  const token = useSelector((state) => state.auth.token); // Get the token from Redux
  const userID = useSelector((state) => state.auth.id); // Get the userID from Redux

  const dispatch = useDispatch();
  const navigate = useNavigate();



  const handleActiveChange = (event) => {
    setActive(event.target.checked);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!designationName.trim()) {
      newErrors.designationName = "Designation name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!validateForm()) {
      return; // Exit if validation fails
    }

    const formData = {
      designationName,
      active,
    };


    const addDesignationCall = async () => {
      setIsloading(true);
      const input_token = designationName; // Replace with your actual token
      const apiUrl = 'create_designation'; // Replace with the actual API endpoint

      const dataInput = {
        designation_name: designationName,
        login_user_id: userID,
        status: active ? 1 : 0
      };

      try {
        const data = await authApi(input_token, dataInput, apiUrl, token);

        if (data && data.success) {
          await Toastmessage(data.message, true);
          setDesignationName('');
          navigate('/designation');
        } else if (data && data.message === 'Token has expired') {
          setIsloading(false);
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else if (data === undefined) {
          setIsloading(false);
          await Toastmessage('No response from server', false);
        } else {
          setIsloading(false);
          await Toastmessage(data?.message || 'An error occurred', false);
        }

      } catch (error) {
        setIsloading(false);
        console.error("Error fetching data:", error);
        if (error.response && error.response.status === 401) {
          dispatch(logout());
          localStorage.removeItem('token');
          await Toastmessage('Session expired. Redirecting to login...', false);
          navigate('/login');
        } else {
          await Toastmessage('Something went wrong', false);
        }
      }
    }

    addDesignationCall();
  };

  const RequiredLabel = ({ children }) => (
    <>
      {children} <span style={{ color: 'red' }}>*</span>
    </>
  );

  return (

    <Box>

      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom='20px'
        backgroundColor='var(--theme-bg-light)'
        padding={2}
        borderRadius={1}
      >
        {/* Left Section */}
        <Box display="flex" alignItems="center">
          <User style={{ marginRight: 8, fontSize: '12px', color: 'var(--icon-color)' }} />
          <Typography fontSize={12} color="var(--text-color)">
            Add New Designation 
          </Typography>
        </Box>

        {/* Right Section */}
        <Button
          variant="outlined"
          component={Link}
          to="/designation"
          sx={{
            backgroundColor: 'var(--back-button)',
            color: "var(--back-color)",
            fontWeight: 'bold',
            border: 'none',
            padding: '10px 20px'
          }}
          startIcon={<ChevronLeft sx={{ fontSize: 17 }} />}
          style={{ textTransform: 'none' }}
        >
          Back to Designation List
        </Button>
      </Box>



      <Box className="card-box" p={3} sx={{ borderRadius: '8px', border: '1px solid var(--border-color)', m:3 }} >
        <form onSubmit={handleSubmit}>
          <Box className="sub-header">

            <Typography sx={{ color: '#3570FF', fontSize: '14px', fontWeight: 'bold' }}>
              {/* <Link to="/designation" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                <ArrowLeft size={20} style={{ marginRight: '8px' }} /> */}
                Add New Designation
              {/* </Link> */}
            </Typography>
            <FormControlLabel
              control={<Switch checked={active} onChange={handleActiveChange} />}
              label={
                <Typography sx={{ color: active ? 'green' : 'red', fontWeight: 'bold' }}>
                  Active : {active ? 'Yes' : 'No'}
                </Typography>
              }
            />
          </Box>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}><RequiredLabel>Designation Name</RequiredLabel></Typography>
              <TextField
                fullWidth
                placeholder="Enter the designation name"
                variant="outlined"
                value={designationName}
                error={!!errors.designationName}
                helperText={errors.designationName} // Display error message
                InputProps={{
                  sx: { borderRadius: '8px' },
                }}
                onChange={(e) => setDesignationName(e.target.value)}
              />
            </Grid>
            

            <Grid size={12} sx={{ textAlign: 'center' }}>
              <Button
                type="submit"
                variant="contained"
                disabled={isLoading}
                startIcon={<PlusCircle size={20} />}
                 className='btn-theme-button'
              >
                Add New Designation
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>

    </Box>
  );
}
